import { Flame, Heart, Crown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

interface PatreonTierProps {
  title: string;
  price: string;
  description: string;
  icon: 'flame' | 'heart' | 'crown';
  link: string;
}

const icons = {
  flame: Flame,
  heart: Heart,
  crown: Crown,
};

export const PatreonTier: React.FC<PatreonTierProps> = ({
  title,
  price,
  description,
  icon,
  link
}) => {
  const Icon = icons[icon];
  const { t } = useLanguage();
  
  return (
    <div className="bg-card rounded-lg border border-border p-6 flex flex-col h-full hover:border-foreground/20 transition-colors">
      <div className="mb-4">
        <Icon className="w-5 h-5 text-muted-foreground" />
      </div>
      
      <h3 className="text-lg font-medium mb-1">{title}</h3>
      
      <div className="mb-4">
        <span className="text-2xl font-semibold">{price}</span>
        <span className="text-muted-foreground text-sm ml-1">/{t('patreon', 'recurring')}</span>
      </div>

      <p className="text-muted-foreground text-sm mb-6 flex-grow leading-relaxed">{description}</p>

      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="block w-full text-center bg-foreground text-background py-2.5 rounded-md text-sm font-medium hover:opacity-90 transition-opacity"
      >
        {t('patreon', 'button')}
      </a>
    </div>
  );
};
